import { render, staticRenderFns } from "./Connoisseur.vue?vue&type=template&id=68d65a16&scoped=true&"
import script from "./Connoisseur.vue?vue&type=script&lang=js&"
export * from "./Connoisseur.vue?vue&type=script&lang=js&"
import style0 from "./Connoisseur.vue?vue&type=style&index=0&id=68d65a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d65a16",
  null
  
)

export default component.exports